module.exports = __WEBPACK_EXTERNAL_MODULE_89__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 89
// module chunks = 0